import i18n from 'i18next';
import config from 'utils/config';
export default function getCoachAiName() {
  return config.coachAiName || i18n.t('coach_ai_name');
}